"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _createMonitoringEpic = _interopRequireDefault(require("./createMonitoringEpic"));

var _epics = _interopRequireDefault(require("settings-ui-sdk/epics"));

var _default = function _default(rootModule) {
  return (0, _reduxObservable.combineEpics)((0, _createMonitoringEpic.default)(rootModule), rootModule.rootEpic, _epics.default);
};

exports.default = _default;
module.exports = exports.default;